import React, { useEffect, useState } from "react";
import ConfigurationValidationAction from "../../../Actions/ConfigurationValidationAction";
import configurationValidationStore from "../../../Stores/ConfigurationValidationStore";
import ConfigValidationConstants from "../../../Constants/ConfigurationValidationConstants";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "../../../Context/LanguageContext";

export default function ConfigurationValidationList() {
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [configValidationDetails, setConfigValidationDetails] = useState([]);
  const { localization } = useLanguageContext();

  const getConfigValidation = () => {
    setGlobalSpinner(true);
    ConfigurationValidationAction.getConfigValidation();
  };
  useEffect(() => {
    getConfigValidation();
    function getConfigValidationSuccess() {
      var res = configurationValidationStore.getResult();
      if (res.length > 0) {
        setConfigValidationDetails(res);
        setGlobalSpinner(false);
      } else {
        setConfigValidationDetails([]);
        setGlobalSpinner(false);
      }
    }

    function getConfigValidationFailure() {
      var res = configurationValidationStore.getResult();
      setConfigValidationDetails([]);
      setGlobalSpinner(false);
    }

    configurationValidationStore.addChangeListener(
      ConfigValidationConstants.GET_CONFIG_VALIDATION_SUCCESS,
      getConfigValidationSuccess
    );

    configurationValidationStore.addChangeListener(
      ConfigValidationConstants.GET_CONFIG_VALIDATIONT_FAILURE,
      getConfigValidationFailure
    );

    return () => {
      configurationValidationStore.removeChangeListener(
        ConfigValidationConstants.GET_CONFIG_VALIDATION_SUCCESS,
        getConfigValidationSuccess
      );

      configurationValidationStore.removeChangeListener(
        ConfigValidationConstants.GET_CONFIG_VALIDATIONT_FAILURE,
        getConfigValidationFailure
      );
    };
  }, []);
  return (
    <>
      <div className="w-100 h-100" id="content">
        <div className="pt-4 px-3 d-flex justify-content-between">
          <h3>{localization.configValidation}</h3>
        </div>
        {configValidationDetails.length > 0 && (
          <div style={{ maxHeight: "83vh", overflow: "scroll" }}>
            {configValidationDetails.map((item, index) => {
              return (
                <div className="row" key={index}>
                  <ul>
                    <li>
                      <span className="font-weight-bolder"> {item.plant}</span>
                      {item.anlagegruppes.map((subitem) => {
                        return (
                          <ul className="mt-2">
                            <li>
                              <span className="font-weight-bold">
                                {localization.equipmentGroupName +
                                  ":" +
                                  " " +
                                  subitem.anlagegruppe}
                              </span>
                              <ul>
                                {subitem.details.map((item) => (
                                  <li>
                                    {item.title}
                                    <ul>
                                      {item.warnings.map((_warning) => (
                                        <li>{_warning}</li>
                                      ))}
                                    </ul>
                                  </li>
                                ))}
                              </ul>
                            </li>
                          </ul>
                        );
                      })}
                      <ul></ul>
                    </li>
                  </ul>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
}
